export enum LOGGER {
  danger = 'color: #cd3333',
  info = 'color: #1874cd;font-weight:bold;font-size:20px',
  success = 'color: #00cd00',
  warning = 'color: #ee7600',
  request = 'color: #7131f9',
  requestResult = 'color: #f200ff',
}
